import { LoggingServicePort } from '../../../shared/ports'

export class PerformanceTrackingService {
  private start: DOMHighResTimeStamp | null = null

  constructor(
    private loggingService: LoggingServicePort,
    private logFraction: number = 0.001
  ) {}

  init(): void {
    if (Math.random() <= this.logFraction) {
      this.start = performance.now()
    }
  }

  trackOTBannerLoadTime(): void {
    if (this.start) {
      this.loggingService.logMessage(
        'Consent banner loaded in ' +
          Math.round(performance.now() - this.start) +
          ' ms'
      )
    }
  }
}
